import { Component, Input, OnInit, Signal, signal, WritableSignal } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MapService } from '@app/_services/map.service';
import { SettingsService } from '@app/_services/settings.service';
import { EntityName } from '@app/_types/generic.type';
import { SvgComponent } from '../../svg/svg.component';
import { CommonModule } from '@angular/common';
import { InputCheckboxComponent } from '../../inputs/input-checkbox/input-checkbox.component';
import { AnalyticsService } from '@app/_services/analytics.service';

@Component({
  selector: 'app-filter-feature',
  imports: [
    CommonModule,
    MatMenuModule,
    SvgComponent,
    InputCheckboxComponent
  ],
  templateUrl: './filter-feature.component.html',
  styleUrl: './filter-feature.component.scss'
})

export class FilterFeatureComponent implements OnInit {

  @Input() value: WritableSignal<EntityName[]> = signal<EntityName[]>([]);
  @Input() multiple: boolean = false;
  @Input() label: string = '';
  @Input() hiddenValues: EntityName[] = [];
  entityFilterFeature: EntityName[] = ['todo', 'note', 'list', 'habit', 'journal', 'calendarIntegration', 'moneyTracker', 'focus'];
  entityFeatureMap: Signal<Record<EntityName, string>> = this.mapService.entityFeatureMap;
  valueToIconMap: Record<EntityName, string> = {
    todo: 'todo',
    habit: 'habit',
    journal: 'journal',
    calendarIntegration: 'calendar',
    moneyTracker: 'moneyTracker',
    note: 'note',
    list: 'list',
    focus: 'focusTrainer',
  };

  // Local optimistic state — updates instantly on click, independent of store propagation
  selectedItems = signal<EntityName[]>([]);

  constructor(public ss: SettingsService, private mapService: MapService, private as: AnalyticsService) {

  }

  ngOnInit(): void {
    this.selectedItems.set(this.value());
  }

  getLabel(): string {
    if (this.selectedItems().length === 0) {
      return this.ss.t('features_title');
    } else if (this.selectedItems().length === 1) {
      return this.entityFeatureMap()[this.selectedItems()[0]];
    } else {
      return this.selectedItems().length + ' ' + this.ss.t('features_title');
    }
  }

  onFeatureSelected(value: EntityName, event: MouseEvent): void {
    this.as.filterEvent('feature', value);
    if (this.multiple) {
      const current = this.selectedItems();
      const updated = current.includes(value)
        ? current.filter((v) => v !== value)
        : [...current, value];
      // Update local state immediately (optimistic)
      this.selectedItems.set(updated);
      // Update store — triggers data reload in background
      this.value.set(updated);
      event.stopPropagation();
    } else {
      this.selectedItems.set([value]);
      this.value.set([value]);
    }
  }

}
